<!--
  @Description 权限分配
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader title="权限分配"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 查询面板 -->
        <!-- <div class="search-dv" v-if="searchFormVisible">
          <SearchForm ref="SearchForm"></SearchForm>
        </div> -->

        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>

        <!-- 权限分配表格 -->
        <div class="approve-table-dv">
          <!-- 角色 -->
          <div class="left-role-dv" :style="{ height: this.approveCardHeight }">
            <div class="role-list-dv" :style="{ height: this.tableHeight }">
              <navList
                :listData="roleList"
                :id="id"
                title="角色名称"
                listKey="name"
                indexKey="id"
                :indexValue="indexValue"
                @itemClick="changeRole"
              ></navList>
            </div>
          </div>
          <!-- 用户明细 -->
          <div
            class="middle-user-dv"
            :style="{ height: this.approveCardHeight }"
          >
            <div class="table-dv">
              <vxe-grid
                ref="xTableEmployee"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="detailListBRoleEmployee"
                size="mini"
                :mouse-config="{ area: true }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumnsEmployee"
              >
              </vxe-grid>
            </div>
          </div>
          <!-- 菜单明细 -->
          <div
            class="right-menu-dv"
            :style="{ height: this.approveCardHeight }"
          >
            <div class="table-dv">
              <vxe-grid
                ref="xTableMenu"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="detailListBRoleAuthority"
                size="mini"
                :mouse-config="{ area: true }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumnsMenu"
                @cell-click="cellClickEvent1"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddOrSeeRoleModal
      :parentData="this"
      :updateForm="form"
      :modalType.sync="modalType"
      @updateModalType="updateModalType"
      ref="AddOrSeeRoleModal"
    />
    <!-- 菜单选择框 -->
    <MenuSpecial ref="MenuSpecial" modalType="see"></MenuSpecial>
  </div>
</template>

<script>
import AddOrSeeRoleModal from './AddOrSeeRoleModal'
import MenuSpecial from './MenuSpecial'
// import navList from './navList'
export default {
  name: 'BRole',
  components: {
    AddOrSeeRoleModal,
    // navList,
    MenuSpecial
  },
  data() {
    return {
      id: 0,
      searchFormVisible: false,
      gridColumnsMenu: [
      ],
      gridColumnsEmployee: [
      ],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: true, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: true, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 角色列表数据
      roleList: [
      ],
      form: {
      },
      detailListBRoleEmployee: [],
      detailListBRoleAuthority: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 模态窗类型
      modalType: '',
      indexValue: ''
    }
  },
  mounted() {
    this.list('one')
  },
  created() {
    this.InitColumn()
  },
  methods: {
    // 初始化
    InitColumn() {
      this.gridColumnsMenu = [
        { type: 'seq', width: 40 },
        { title: '模块', field: 'module' },
        { title: '菜单', field: 'text' },
        {
          field: 'iSee',
          title: '查看',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <vxe-checkbox v-model={row.iSee} disabled={true}></vxe-checkbox>
              ]
            }
          }
        },
        {
          field: 'iEdit',
          title: '编辑',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <vxe-checkbox v-model={row.iEdit} disabled={true}></vxe-checkbox>
              ]
            }
          }
        },
        { field: 'type', title: '菜单类型', cellType: 'string' },
        {
          field: 'more',
          title: '更多',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <el-button type="text" size="small" disabled={!row.hasSpecial || !this.Authority.see}>更多</el-button>
              ]
            }
          }
        }
        // { title: '列权限' },
      ]
      this.gridColumnsEmployee = [
        { type: 'seq', width: 40 },
        { title: '姓名', field: 'name' },
        { title: '用户名', field: 'num' },
        { title: '职位', field: 'post' },
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    changeRole(item) {
      this.form = item
      this.indexValue = String(item.id)
      this.getBoth(item.id)
    },
    // 新增
    add() {
      this.modalType = '新增'
      this.$refs.AddOrSeeRoleModal.formVisible = true
    },
    // 修改按钮
    update() {
      if (this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      if (this.form.writerID !== this.$store.state.userInfo.userId) {
        this.$message.error('不可修改他人单据!')
        return
      }
      this.modalType = '修改'
      this.form = {
        ...this.form,
        detailListBRoleEmployee: this.detailListBRoleEmployee,
        detailListBRoleAuthority: this.detailListBRoleAuthority,
      }
      // this.$refs.AddOrSeeRoleModal.form = {
      //   ...this.form,
      //   detailListBRoleEmployee: this.detailListBRoleEmployee,
      //   detailListBRoleAuthority: this.detailListBRoleAuthority,
      // }
      // this.$refs.AddOrSeeRoleModal.id = this.id
      this.$refs.AddOrSeeRoleModal.formVisible = true
    },
    // 删除数据
    delete() {
      const that = this
      if (this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      if (this.form.writerID !== this.$store.state.userInfo.userId) {
        this.$message.error('不可删除他人单据!')
        return
      }
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { data: res } = await that.$http.delete('/Base/BRole/' + this.id)
          if (!res.isSuccess) {
            that.$message.error(res.errorMessage)
            return false
          }
          that.$message.success('删除成功！')
          that.list('one')
        })
        .catch(() => { })
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.list()
    },
    // 获取数据
    async list(type = 'list', id = 0) {
      const { data: res } = await this.$http.post('/Base/BRole/list',
        {
          pageIndex: 1,
          pageSize: 99999,
          seeType: this.Authority.seeType
        })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.roleList = res.data.rows
      if (this.roleList.length > 0) {
        switch (type) {
          case 'list':
            break
          case 'one':
            this.form = this.roleList[0]
            this.indexValue = String(this.roleList[0]['id'])
            this.getBoth(this.roleList[0]['id'])
            break
          case 'add':
          case 'update':
            this.getBoth(id)
            break
        }
      }
    },
    // 获取明细数据
    async getBoth(id) {
      this.id = id
      const { data: res } = await this.$http.get('/Base/BRole/both',
        {
          params: {
            id: id
          }
        }
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.detailListBRoleEmployee = res.data.detailListBRoleEmployee
      this.detailListBRoleAuthority = res.data.detailListBRoleAuthority
    },
    // 修改模态窗类型
    updateModalType(Str) {
      this.modalType = Str
    },
    // 点击单元格
    cellClickEvent1({ row, column }) {
      if (column.title === '更多' && row.hasSpecial) {
        if (row.id > 0) {
          this.$refs.MenuSpecial.roleID = this.id
          this.$refs.MenuSpecial.bAuthorityListID = row.bAuthorityListID
          this.$refs.MenuSpecial.ifCanSave = this.Authority.edit
          this.$refs.MenuSpecial.formVisible = true
        } else {
          this.$message.warning('行明细未保存，请先保存')
        }
      }
    },
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
}
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.middle-user-dv {
  width: 35%;
}
// 权限菜单列表
.right-menu-dv {
  width: 50%;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
